import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const CheckIcon = ({ stroke, ...props }: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.5 4.7998C4.5 4.24752 4.94772 3.7998 5.5 3.7998H18C18.5523 3.7998 19 4.24752 19 4.7998V18.8796C19 19.6885 18.0895 20.1627 17.4267 19.6989L15.8269 18.5795C15.4711 18.3306 14.9955 18.3397 14.6495 18.6019L12.3541 20.3419C11.9969 20.6127 11.5031 20.6127 11.1459 20.3419L8.85053 18.6019C8.50454 18.3397 8.02886 18.3306 7.67314 18.5795L6.07331 19.6989C5.41051 20.1627 4.5 19.6885 4.5 18.8796V4.7998Z"
        stroke={strokeColor}
        strokeWidth={1.5}
      />
      <path
        d="M7.44995 8H16.0499"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
      <path
        d="M7.44995 11.5996H11.7499"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};
